import api from './api';

export const bulkQualityManagementService = {

  /** Search Bulk Trello board for a card by batch/card number */
  searchCard: async (batchNumber: string) => {
    const response = await api.get('/bulk-quality-management/search-card', {
      params: { batch_number: batchNumber },
    });
    return response.data;
  },

  /** Get all reviews (admin/manager view) */
  getAll: async (params?: {
    status?: string;
    assigned_to?: string;
    rejection_type?: string;
    search?: string;
  }) => {
    const response = await api.get('/bulk-quality-management', { params });
    return response.data;
  },

  /** Get reviews assigned to the logged-in user */
  getMyAssignments: async () => {
    const response = await api.get('/bulk-quality-management/my-assignments');
    return response.data;
  },

  getById: async (id: number) => {
    const response = await api.get(`/bulk-quality-management/${id}`);
    return response.data;
  },

  getStats: async () => {
    const response = await api.get('/bulk-quality-management/stats');
    return response.data;
  },

  /** Check if the Trello card for a review is currently in "Printing Out" */
  checkCardStatus: async (id: number) => {
    const response = await api.get(`/bulk-quality-management/${id}/card-status`);
    return response.data;
  },

  create: async (data: {
    trello_card_id?: string;
    trello_card_name?: string;
    batch_number: string;
    source_list_name?: string;
    source_board_name?: string;
    rejection_type: 'internal' | 'external';
    ocl_sub_type?: 'internal' | 'external';
    machine_type: 'rotary' | 'digital';
    issue_type?: 'color' | 'layout';
    external_issues?: string[];
    external_other_issue?: string;
    description?: string;
    action_plan?: string;
  }) => {
    const response = await api.post('/bulk-quality-management', data);
    return response.data;
  },

  updateStatus: async (id: number, status: string) => {
    const response = await api.patch(`/bulk-quality-management/${id}/status`, { status });
    return response.data;
  },

  /** Send review for approval (backend verifies card is in Printing Out) */
  sendForApproval: async (id: number) => {
    const response = await api.post(`/bulk-quality-management/${id}/send-for-approval`);
    return response.data;
  },

  /** Approve the current step in the approval chain */
  approve: async (id: number) => {
    const response = await api.post(`/bulk-quality-management/${id}/approve`);
    return response.data;
  },

  /** Get reviews pending logged-in user's approval */
  getPendingApprovals: async () => {
    const response = await api.get('/bulk-quality-management/pending-approvals');
    return response.data;
  },
};

export default bulkQualityManagementService;
